import { CardString } from 'pokersolver'
import { WalkthroughPlayersIds } from './index'

export type DealTheFlopStep = {
  id: ''
  communityCards: CardString[]
  players: Record<WalkthroughPlayersIds, CardString[]>
  answer: {
    id: WalkthroughPlayersIds
    title: string
    description: string
  }
}

export const DealTheFlopCards = (step: number) => {
  const info = DealTheFlopSteps[step]
  return info.players
}

export const DealTheFlopCommunityCards = (step: number) => {
  const info = DealTheFlopSteps[step]
  return info.communityCards
}

const EmptyStep: DealTheFlopStep = {
  id: '',
  communityCards: [],
  players: {
    bettina: [],
    esther: [],
    dianne: [],
    jane: [],
    tara: []
  },
  answer: {
    id: 'bettina',
    title: '',
    description: ''
  }
}

export const DealTheFlopSteps: DealTheFlopStep[] = [
  EmptyStep,
  {
    id: '',
    communityCards: ['As', '3s', 'Jh'],
    players: {
      bettina: ['2h', '3c'],
      esther: ['8h', '8d'],
      dianne: ['Ac', 'Jc'],
      jane: ['4d', '7c'],
      tara: ['Ad', '7s']
    },
    answer: {
      id: 'dianne',
      title: 'Dianne is winning',
      description: 'Dianne is currently leading with two pairs (Aces and Jacks) after the flop.'
    }
  },
  {
    id: '',
    communityCards: ['2d', '2h', '6c'],
    players: {
      bettina: ['Tc', '7d'],
      esther: ['Kh', '3c'],
      dianne: ['Qh', 'Jh'],
      jane: ['Ah', 'Kc'],
      tara: ['Qc', '5h']
    },
    answer: {
      id: 'jane',
      title: 'Jane is winning',
      description:
        'After the flop, all players still lack their own pairs, and it remains a high card situation. Jane continues to hold the highest card with an Ace.'
    }
  },
  {
    id: '',
    communityCards: ['8s', '6h', '2c'],
    players: {
      bettina: ['7d', '7s'],
      esther: ['Ac', 'Ks'],
      dianne: ['Qh', 'Qs'],
      jane: ['Jc', 'Tc'],
      tara: ['9h', '9d']
    },
    answer: {
      id: 'dianne',
      title: 'Dianne is winning',
      description: "The flop doesn't help anyone in this case, so Dianne is in the lead with a pair of Queens."
    }
  },
  {
    id: '',
    communityCards: ['Td', '8c', '3h'],
    players: {
      bettina: ['Js', 'Jh'],
      esther: ['Kd', 'Qd'],
      dianne: ['9s', '9c'],
      jane: ['8h', '7h'],
      tara: ['Ah', 'Th']
    },
    answer: {
      id: 'bettina',
      title: 'You are winning',
      description:
        'Jane has a Pair of 8s, Dianne has a Pair of 9s, Tara has a Pair of 10s, but you are still the leader with a Pair of Jacks.'
    }
  },
  {
    id: '',
    communityCards: ['7s', '8s', 'Js'],
    players: {
      bettina: ['9s', 'Ts'],
      esther: ['Qd', 'Qh'],
      dianne: ['5h', '6h'],
      jane: ['Jc', '8c'],
      tara: ['Ks', 'Kh']
    },
    answer: {
      id: 'bettina',
      title: 'You are winning',
      description: 'After the flop, you are leading with a Straight Flush.'
    }
  },
  {
    id: '',
    communityCards: ['5d', '8d', 'Td'],
    players: {
      bettina: ['6d', '9d'],
      esther: ['7h', '7s'],
      dianne: ['2d', 'Qd'],
      jane: ['Tc', '8c'],
      tara: ['Ah', '2h']
    },
    answer: {
      id: 'dianne',
      title: 'Dianne is winning',
      description:
        'Because of the flop, Dianne is leading with a Flush. You also have a Flush, but Dianne has a higher card.'
    }
  },
  {
    id: '',
    communityCards: ['2s', '4s', '6s'],
    players: {
      bettina: ['7s', '8h'],
      esther: ['9d', '9h'],
      dianne: ['Kh', 'Qc'],
      jane: ['3d', '5d'],
      tara: ['Jh', 'Th']
    },
    answer: {
      id: 'jane',
      title: 'Jane is winning',
      description: 'Esther has a Pair of Nines, but Jane leads with a Straight.'
    }
  },
  EmptyStep
]
